import React from 'react';
import { Tooltip, Icon, colors } from '@dexma/ui-components';
import { StyledAlertWarning } from 'adapter/in/dashboards/components/SmallAlertTooltip/style';

type SmallAlertTooltipProps = {
    tooltipMessage: string;
};

const SmallAlertTooltip = (props: SmallAlertTooltipProps) => {
    const { tooltipMessage } = props;
    return (
        <StyledAlertWarning data-testid='small-alert-tooltip'>
            <Tooltip title={tooltipMessage}>
                <Icon color={colors.gray800} name='warning' />
            </Tooltip>
        </StyledAlertWarning>
    );
};

export default SmallAlertTooltip;
